<template>
    <div class="profile-events" v-if="(photos && photos.length > 0) || itsYou">
        <div class="profile-title">
            <div class="profile-title-wrap">
            <div class="profile-title-wrap">
                <h3>Фотографии {{photos ? `(${photos.length})` : ''}}</h3>
                <div class="profile-title__icon" v-if="itsYou">
                    <input
                    class="card-panel__input"
                    type="file"
                    @change="loadPhotos($event, 'photos')"
                    name="avatar"
                    max-size="10000"
                    multiple
                    accept="image/*"
                    title="Добавить фотографию"
                    />
                    <font-awesome-icon icon="plus" />
                </div>  
            </div>
            
            </div>
        </div>
        <!-- Слайдер фото -->
        <VueSlickCarousel 
            class="profile-photos" 
            :swipeToSlide="true" 
            :arrows="false"
            :variableWidth="true" 
            :infinite="false" 
            v-if="photos && photos.length > 0"
        >
            <!-- Само фото -->
            <div
            :v-if="photos"
            class="profile-photos__item"
            v-for="(image, index) of photos"
            :key="image.id"
            :style="{ backgroundImage: 'url(' + image.large + ')' }"
            @mousewheel.passive="slideByScroll($event)"
            @mousedown="startDrag"
            @mouseup="showFullPhoto($event, photos, index)"
            >
            <div class="profile-photos__delete" @mouseup.stop="openDeleting(image)" v-if="itsYou">
                <font-awesome-icon icon="trash-alt" />
            </div>
            <div v-if="image.loading" class="card__avatar_loader">
                <svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                    <animateTransform 
                    attributeName="transform" 
                    attributeType="XML" 
                    type="rotate"
                    dur="1s" 
                    from="0 50 50"
                    to="360 50 50" 
                    repeatCount="indefinite" />
                </path>
            </svg>
            </div>

            </div>
        </VueSlickCarousel>
        <div class="profile-photos" v-else>
            <div
            v-if="(!photos || photos.length === 0) && itsYou"
            class="profile-photos__add"
            >
            <img src="@/assets/images/icons/icon_plus.svg">
            <input
                class="card-panel__input"
                type="file"
                @change="loadPhotos($event, 'photos')"
                name="avatar"
                max-size="10000"
                multiple
                accept="image/*"
                title="Добавить фотографию"
            />
            </div>
        </div>
        <div class="confirm" v-if="photo_delete">
            <div class="confirm-container">
            <h5>Вы действительно хотите удалить фотографию?</h5>
            <div class="confirm-buttons">
                <div class="button" @click="deletePhoto()">Да</div>
                <div class="button" @click="photo_delete = null">Нет</div>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
export default {
    name: 'ProfilePhotos',
    props: {
        photos: {
            type: Array,
            require: true
        },
        itsYou: {
            type: Boolean,
            require: true
        }
    },
    data: () => {
        return {
            start: null,
            photo_delete: null,
            first_click: null
        }
    },
    components: {
      VueSlickCarousel: () => import("vue-slick-carousel")
    },
    computed: {
        getUser () {
            return this.$store.getters.getAuthUser
        },
    },
    methods: {
        loadPhotos(input, path) {
            let files = input.target.files;
            files.length > 6
                ? this.$store.dispatch('addError', {
                    message: 'Допустимо загружать максимум 6 фотографий за раз',
                })
                : '';
            files.forEach(async (element, index) => {
                if (index < 6) {
                if (element.size / 1024 > 10000) {
                    this.$store.dispatch('addError', {message: 'Размер одной из фотографий превышает 5MB'});
                } else {
                    var reader = new FileReader();
                    reader.readAsDataURL(element)
                    reader.onload = async () => {
                    let url = reader.result;
                    let type = element.type.split('/')[1];
                    let size = element.size / 1024;
                    let name = this.$moment().format('ss-mm-HH_DD-MM-YYYY') + '_' + Math.round(Math.random() * 1000);
                    this.photos ? this.photos.unshift({
                        loading: true
                    }) : this.photos = [{
                        loading: true
                    }];
                    // let index = this.block.value.length - 1;
                    await this.$store.dispatch('uploadImage', {url, type: type || 'jpeg', name, size, path, resize: 2000})
                        .then(response => {
                        response.Location 
                            ? this.addPhoto(response.Location) 
                            : this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'});
                        })
                        .catch(() => {
                        this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'})
                        });
                    };

                    reader.onerror = function() {
                    this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
                    };
                }
                }
            });
        },
        async addPhoto(url) {
            await this.$store.dispatch('addPhotoProfile', {url, user: this.getUser.id})
            .then(response => {
                let photos = this.photos;
                photos.splice(photos.indexOf(photos.find(item => item.loading)), 1);
                photos.unshift(response);
            })
            .catch(() => {
                this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
            });
            // await this.$store.dispatch('editProfile', {key: 'avatar', val: url});
            this.loading_avatar = false
        },
        slideByScroll(event) {
            event.deltaY === 0 ? event.deltaX > 0 ? this.$refs.carousel.next() : this.$refs.carousel.prev() : '';
        },
        startDrag(event) {
            this.start = {
                x: event.clientX,
                y: event.clientY
            }
        },
        showFullPhoto(event, photos, active) {
            if (this.start){
                let x = Math.abs(this.start.x - event.clientX);
                if (x < 2) {
                    this.$store.dispatch('setPhotos', {photos: photos, active: active})
                    this.$store.dispatch('setPhotosState', true)
                }
            }
        },
        firstClick(event) {
            this.first_click = {
                x: event.clientX,
                y: event.clientY
            }
        },
        openDeleting(image) {
            this.photo_delete = image
        },
        deletePhoto() {
            this.photo_delete ? this.$store.dispatch('deleteImage', {key: this.photo_delete.large})
            .then(() => {
                this.deletePh()
            }).catch(() => {
                this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
            }) : ''
        },
        deletePh() {
            this.$store.dispatch('deletePhotoProfile', {image: this.photo_delete})
            .then(() => {
                let photos = this.photos;
                let finded = photos.find(image => image.id === this.photo_delete.id);
                photos.splice(photos.indexOf(finded), 1);
                this.photo_delete = null
                this.$store.dispatch('addNotification', {message: 'Фото удалено'})
            })
        },
        async deleteImage(image) {
            await this.$store.dispatch('deleteImage', {key: image});
            await this.$store.dispatch('editProfile', {key: 'avatar', val: 'https://mir-s3-cdn-cf.behance.net/project_modules/disp/1bcdd944565991.5817acde24c51.gif'});
        },
    }
}
</script>